import { render, staticRenderFns } from "./ProgressBarMetric.vue?vue&type=template&id=60638449&scoped=true"
import script from "./ProgressBarMetric.vue?vue&type=script&lang=js"
export * from "./ProgressBarMetric.vue?vue&type=script&lang=js"
import style0 from "./ProgressBarMetric.vue?vue&type=style&index=0&id=60638449&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60638449",
  null
  
)

export default component.exports